import React from 'react'
import {
  Users,
  DollarSign,
  CheckCircle,
  MapPin,
  Target,
  Bell,
  BookMarked,
  Radio,
  Lightbulb,
} from 'lucide-react'
import MetricCard from '../analytics/MetricCard'
import { formatCurrency } from '../../lib/formatCurrency'
import { BandHeading } from './OverviewPanel'

/**
 * Live pulse KPI strip — only metrics from allowed modules.
 */
export default function LivePulse({
  showClientKpis,
  clientStats,
  raceStats,
  alertCount,
  resourceCount,
  bplStats,
  ideaBoardStats,
  loading,
}) {
  const hasAny =
    (showClientKpis && (clientStats || loading)) ||
    raceStats ||
    alertCount != null ||
    resourceCount != null ||
    bplStats ||
    ideaBoardStats

  if (!hasAny) return null

  return (
    <section className="overview-band overview-fade-in" aria-label="Live pulse">
      <BandHeading title="Live pulse" subtitle="Metrics from modules you can open" />
      <div className="overview-metric-grid">
        {loading && showClientKpis && !clientStats
          ? [1, 2, 3, 4].map((i) => <div key={i} className="overview-skeleton" style={{ height: 100 }} />)
          : null}
        {showClientKpis && clientStats ? (
          <>
            <MetricCard title="Total Clients" value={clientStats.total} icon={Users} />
            <MetricCard
              title="Total Budget"
              value={formatCurrency(clientStats.totalBudget)}
              icon={DollarSign}
            />
            <MetricCard
              title="Active Clients"
              value={clientStats.active}
              icon={CheckCircle}
              trend={`${clientStats.activePct}% of total`}
              trendUp
            />
            <MetricCard title="States" value={clientStats.states} icon={MapPin} />
          </>
        ) : null}
        {raceStats ? (
          <MetricCard
            title="Sweep overdue"
            value={raceStats.digitalOverdue + raceStats.linearOverdue}
            icon={Target}
            trend={`${raceStats.activeRaces} active races`}
            trendUp={raceStats.digitalOverdue + raceStats.linearOverdue === 0}
          />
        ) : null}
        {alertCount != null ? (
          <MetricCard title="AdImpact alerts" value={alertCount} icon={Bell} />
        ) : null}
        {resourceCount != null ? (
          <MetricCard title="Resource links" value={resourceCount} icon={BookMarked} />
        ) : null}
        {bplStats ? (
          <MetricCard title="BPL stations" value={bplStats.stations} icon={Radio} />
        ) : null}
        {ideaBoardStats ? (
          <MetricCard title="Open ideas" value={ideaBoardStats.openSuggestions} icon={Lightbulb} />
        ) : null}
      </div>
    </section>
  )
}
